export class ExceptionLogMethod {
    exceptionLogId: number;   
    logPathMethod: string;
}
